// lovingly copied from ReferralNoteBox

import './ReferralNote.scss'

import React from 'react'
import moment from 'moment-timezone'
import {
  ASSIGNMENT_AGENT_STATUS,
  ASSIGNMENT_AGENT_STATUS_LISTING,
  ASSIGNMENT_AGENT_STATUS_LEASE,
} from 'common/constants'
import { labelFor } from 'common/util/helper'

const getLabelset = ({ is_lease, transaction_type }) => {
  if (is_lease) {
    return ASSIGNMENT_AGENT_STATUS_LEASE
  }
  if (transaction_type === 'list') {
    return ASSIGNMENT_AGENT_STATUS_LISTING
  }
  return ASSIGNMENT_AGENT_STATUS
}

export const ReferralNote = ({ created_at, is_lease, transaction_type, transaction_status, note }) => {
  return (
    <div className="ReferralNote">
      <div className="ReferralNote__top">
        <div className="Referral_Note__date">{ moment.utc(created_at).local().format("ddd, MMM Do YYYY h:mm A") }</div>
        <div>{ labelFor(getLabelset({ is_lease, transaction_type }), transaction_status) }</div>
      </div>
      <div className="ReferralNote__note">{ note }</div>
    </div>
  )
}
